export default {
    FACULTY_UNIVERSITY_TYPES ({ facultyUniversityTypes }) {
      return facultyUniversityTypes
    },
    BRANCHE_TYPES ({ brancheTypes }) {
      return brancheTypes
    },
    STARTUPHASE_TYPES ({ startupPhaseTypes }) {
      return startupPhaseTypes
    },
    COUNTRY_TYPES ({ countryTypes }) {
      return countryTypes
    },
    CASEQUALITY_TYPES ({ casequalityTypes }) {
      return casequalityTypes
    },
    AFFIRMATION_TYPES ({ affirmationTypes }) {
      return affirmationTypes
    },
    UNIVERSITY_TYPES ({ universityTypes }) {
      return universityTypes
    },
    RECHTSFORM_TYPES ({ rechtsformTypes }) {
      return rechtsformTypes
    },
    LANGUAGES_TYPES ({ languagesTypes }) {
      return languagesTypes
    },
    EDUCATION_TYPES ({ educationTypes }) {
      return educationTypes
    },
    CANTON_TYPES ({ cantonTypes }) {
      return cantonTypes
    },
    SALUTATION_TYPES ({ salutationTypes }) {
      return salutationTypes
    },
    PRIOVLAB_TYPES ({ priovlabTypes }) {
      return priovlabTypes
    },
    PRIOVLABXMAS_TYPES ({ priovlabxmasTypes }) {
      return priovlabxmasTypes
    },
    PROFILCATEGORY_TYPES ({ profilcategoryTypes }) {
      return profilcategoryTypes
    },
    VKCASESTATUS_TYPES ({ vkCaseStatusTypes }) {
      return vkCaseStatusTypes
    },
    INVESTMENT_TYPES ({ investmentTypes }) {
      return investmentTypes
    },
    INVESTMENT_STAGES ({ investmentStages }) {
      return investmentStages
    },
    PROFILE_STATUS ({ profileStatus }) {
      return profileStatus
    },
    TYPEOFORGANIZATION ({ typeofOrganization }) {
      return typeofOrganization
    },
    ROLES ({ roles }) {
      return roles
    },
    VEKMIS_TECHNOLOGY ({ vekmisTechnology }) {
      return vekmisTechnology
    },
    INTERESTS ({ addressInterests }) {
      return addressInterests
    },
    AWARDS ({ awards }) {
      return awards
    },
    SECTORS ({ sectors }) {
      return sectors
    },
    REPORTING_GROUPS ({ reportingGroups }) {
      return reportingGroups
    },
    EVENT_SIGNUP_FUNCTIONS ({ eventSignupFunctions }) {
      return eventSignupFunctions
    },
    EVENT_STARTUP_STAGES ({ eventStartupStages }) {
      return eventStartupStages
    },
    EVENT_STARTUP_SECTORS ({ eventStartupSectors }) {
      return eventStartupSectors
    },
    EVENT_INDUSTRY_EXPERIENCES ({ eventIndustryExperiences }) {
      return eventIndustryExperiences
    },
    EVENT_RELATIONSHIP_UNIS ({ eventRelationshipUnis }) {
      return eventRelationshipUnis
    },
    EVENT_EMPLOYMENTSTATUS ({ eventEmploymentStatus }) {
      return eventEmploymentStatus
    }
  }
